import React, { useRef } from "react";
import "./CustomYouTubePlayer.scss";

const CustomYouTubePlayer = ({ videoId }) => {
  const iframeRef = useRef(null);

  const handleFullscreen = () => {
    const iframe = iframeRef.current;
    if (!iframe) return;

    if (iframe.requestFullscreen) {
      iframe.requestFullscreen();
    } else if (iframe.mozRequestFullScreen) {
      iframe.mozRequestFullScreen();
    } else if (iframe.webkitRequestFullscreen) {
      iframe.webkitRequestFullscreen();
    } else if (iframe.msRequestFullscreen) {
      iframe.msRequestFullscreen();
    }
  };

  return (
    <div className="custom-player">
      <div className="player-wrapper">
        <iframe
          ref={iframeRef}
          src={`https://www.youtube.com/embed/${videoId}?modestbranding=1&rel=0`}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
          allowFullScreen
          title="YouTube video player"
        ></iframe>
        <button className="fullscreen-btn" onClick={handleFullscreen}>
          ⛶
        </button>
      </div>
    </div>
  );
};

export default CustomYouTubePlayer;
